import {NullAsDefault} from "views/Shared";
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {createAsyncAction} from '.'
import {getAsynCacheSelector} from './selectors'

function useAsyncAction({
                            query = {},
                            values = {},
                            apiInfo,
                            onSuccess = NullAsDefault,
                            onError = NullAsDefault
                        }) {
    const mounted = React.useRef(true);

    useEffect(() => {
        return () => {
            mounted.current = false;
        };
    }, []);

    const [
        action = {},
        setAction
    ] = useState()
    const {
        isLoading,
        success,
        errorMessages,
        result,
        time,
        error,
        ...rest
    } = useSelector(state =>
        getAsynCacheSelector(
            state,
            action.asyncId
        )
    )
    const dispatch = useDispatch()
    const handleAsyncAction = (
        _values = {},
        _query = {}
    ) => {
        const action = createAsyncAction({
            query: {
                ...query,
                ..._query
            },
            apiInfo,
            values: {
                ...values,
                ..._values
            }
        })
        setAction(action)
        dispatch(action)
        return action
    }

    useEffect(() => {
        // ✅ Dọn dẹp timeout tránh leak
        if (!action) return;
        const timeout = isLoading ? 300 : 50;
        const timer = setTimeout(() => {
            if (!mounted.current) return; // ✅ Không làm gì nếu đã unmount

            if (error) {
                console.error(errorMessages);
                onError(error, errorMessages);
            } else if (success) {
                onSuccess(result, {
                    action,
                    isLoading,
                    success,
                    errorMessages,
                    result,
                    error,
                    time,
                    ...rest,
                    handleAsyncAction,
                });
            }
        }, timeout);

        return () => clearTimeout(timer); // ✅ Cleanup
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, action, error, success]);

    return {
        action,
        isLoading,
        success,
        errorMessages,
        result,
        error,
        time,
        ...rest,
        handleAsyncAction
    }
}

export default useAsyncAction
